// tslint:disable: naming-convention
import {Action} from '@ngrx/store';
import { PracticeTypeEntity } from '../../../entities/mdqx/practice-type.entity';

export enum PracticeTypeActionTypes {
    GetPracticeTypesRequest = '[PracticeTypes] Get Request',
    GetPracticeTypesResponse = '[PracticeTypes] Get Response'
}

export class GetPracticeTypesRequest implements Action {
    readonly type = PracticeTypeActionTypes.GetPracticeTypesRequest;
}

export class GetPracticeTypesResponse implements Action {
    readonly type = PracticeTypeActionTypes.GetPracticeTypesResponse;
    constructor(public Payload: PracticeTypeEntity[]) {}
}

export type PracticeTypeActions = GetPracticeTypesRequest | GetPracticeTypesResponse;
